export default {
  path: '/opportunities',
  apiClient: null,

  setClient(client) {
    this.apiClient = client;
  },

  async getAll(params = {}) {
    try {
      const response = await this.apiClient.get(`/admin/opportunities`, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getById(id) {
    try {
      const response = await this.apiClient.get(`/admin/opportunities/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getClientOpportunities(params = {}) {
    try {
      const response = await this.apiClient.get(`/opportunities`, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getOpportunityDetail(id, params = {}) {
    try {
      const response = await this.apiClient.get(`/opportunities/${id}`, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async registerIntention(opportunityId, intention) {
    try {
      const response = await this.apiClient.post(`/opportunities/${opportunityId}/intentions`, intention);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCategories() {
    try {
      const response = await this.apiClient.get(`/opportunities/categories`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getMockData() {
    return [
      {
        id: 1,
        title: "Desarrollo Residencial Las Flores",
        description: "Complejo residencial de lujo en zona privilegiada",
        instrument: "Co-ownership",
        annualFixedRate: 12.5,
        term: "24 meses",
        minimumInvestment: 100000,
        interestPayment: "Trimestral",
        commission: "2% al cierre",
        guarantee: "Hipoteca sobre inmueble",
        estimatedIRR: 15.2,
        intentionAmount: 2500000,
        closedAmount: 1200000,
        maxAmount: 5000000,
        minAmount: 100000,
        investorCount: 12,
        deadline: new Date('2024-12-31'),
        publicationDate: new Date('2024-01-15'),
        status: 'active',
        images: [
          'https://picsum.photos/800/600?random=1',
          'https://picsum.photos/800/600?random=2'
        ]
      },
      {
        id: 2,
        title: "Edificio Comercial Centro",
        description: "Edificio de oficinas en el corazón financiero",
        instrument: "Debt",
        annualFixedRate: 10.8,
        term: "18 meses",
        minimumInvestment: 50000,
        interestPayment: "Mensual",
        commission: "1.5% al cierre",
        guarantee: "Garantía bancaria",
        estimatedIRR: 11.5,
        intentionAmount: 800000,
        closedAmount: 450000,
        maxAmount: 2000000,
        minAmount: 50000,
        investorCount: 8,
        deadline: new Date('2024-10-15'),
        publicationDate: new Date('2024-02-01'),
        status: 'active',
        images: [
          'https://picsum.photos/800/600?random=3',
          'https://picsum.photos/800/600?random=4'
        ]
      },
      {
        id: 3,
        title: "Plaza Comercial Norte",
        description: "Centro comercial con locales comerciales premium",
        instrument: "Co-ownership",
        annualFixedRate: 14.0,
        term: "36 meses",
        minimumInvestment: 200000,
        interestPayment: "Semestral",
        commission: "2.5% al cierre",
        guarantee: "Hipoteca sobre inmueble",
        estimatedIRR: 16.8,
        intentionAmount: 1800000,
        closedAmount: 950000,
        maxAmount: 3500000,
        minAmount: 200000,
        investorCount: 7,
        deadline: new Date('2024-11-30'),
        publicationDate: new Date('2024-03-10'),
        status: 'active',
        images: [
          'https://picsum.photos/800/600?random=5',
          'https://picsum.photos/800/600?random=6'
        ]
      }
    ];
  },

  async create(form) {
    try {
      const response = await this.apiClient.post(`/admin/opportunities`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createWithImage(form) {
    try {
      const response = await this.apiClient.post(`/admin/opportunities/with-image`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async update(id, form) {
    try {
      const response = await this.apiClient.put(`/admin/opportunities/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateWithImage(id, form) {
    try {
      const response = await this.apiClient.put(`/admin/opportunities/${id}`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async delete(id) {
    try {
      const response = await this.apiClient.delete(`/admin/opportunities/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async addFile(form) {
    try {
      const response = await this.apiClient.post(`${this.path}/add-file`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteFile(id) {
    try {
      const response = await this.apiClient.delete(`${this.path}/delete-file/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateStatus(id, status) {
    try {
      const response = await this.apiClient.patch(`/admin/opportunities/${id}/status`, { status });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getIntentions(id) {
    try {
      const response = await this.apiClient.get(`/admin/opportunities/${id}/intentions`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async closeOperation(id, operationData) {
    try {
      const response = await this.apiClient.post(`/admin/opportunities/${id}/close-operation`, operationData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getAnalytics(id) {
    try {
      const response = await this.apiClient.get(`/admin/opportunities/${id}/analytics`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Investment intention management
  async getAllIntentions(params = {}) {
    try {
      const response = await this.apiClient.get('/admin/opportunities/intentions/all', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateIntentionStatus(intentionId, status, notes = null) {
    try {
      const response = await this.apiClient.patch(`/admin/opportunities/intentions/${intentionId}/status`, { 
        status, 
        notes 
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async closeIntention(intentionId, operationDate = null, notes = null) {
    try {
      const response = await this.apiClient.post(`/admin/opportunities/intentions/${intentionId}/close`, { 
        operationDate, 
        notes 
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getMyIntentions() {
    try {
      const response = await this.apiClient.get('/opportunities/my/intentions');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteDocument(documentId) {
    try {
      const response = await this.apiClient.delete(`/admin/opportunities/documents/${documentId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
}